<div id="driver-wizard"
     class="row ">
     <div class="d-flex justify-content-between align-items-center card-title"
          id="page-title">
          <h1 *ngIf="!service.justSubscribe"
              [innerHtml]="'RequestYourRecord' | translator: 'base'">
               Request Your PSP Record
          </h1>

          <h1 *ngIf="service.justSubscribe"
              [innerHtml]="'RecordMonitoring' | translator: 'base'">
               Subscribe to PSP Driver Monitoring
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="getStepForPercentComplete()"
                                      [totalSteps]="wizard.totalSteps"></app-complete-bar>
                    <div class="overlay"
                         *ngIf="isVerifying">
                         <h1 class="heading"
                             [innerHtml]="'Loading' | translator: 'base'">
                              Loading...
                         </h1>
                         <img />
                    </div>
                    <h2 [innerHtml]="'DLInfo' | translator: 'base'">DRIVER'S LICENSE INFORMATION</h2>
                    <p class="step-text"
                       [innerHtml]="'DLInfoHelp' | translator: 'base'">
                         For your complete PSP record, please enter each driver's license you've held during
                         the past 5 years.
                    </p>

                    <!-- --------------------------------------------------------------------------------- -->

                    <ng-template #existingDriver
                                 let-modal>
                         <div class="modal-header">
                              <h3 id="existingDriverTitle"
                                  class="modal-title"
                                  [innerHtml]="'ExistingDriverAccount' | translator: 'base'">Existing Driver Account
                              </h3>
                         </div>

                         <div class="modal-body">
                              <div class="alert alert-warning"
                                   role="alert">
                                   <p class="bold">{{ customizeAlreadyExistsMessage() }}</p>
                                   <p [innerHtml]="'ExistingLicenseLogin' | translator: 'base'">Please login with this
                                        account to re-order a driver record.</p>
                                   <p [innerHtml]="'CancelAndLoginDirection' | translator: 'base'">Click "Cancel and Log
                                        In" to cancel this order.</p>
                                   <p [innerHtml]="'TryAgainLicense' | translator: 'base'">Click "Try Again" to re-enter
                                        your license information.</p>
                              </div>
                              <p>
                                  <span [innerHtml]="'ContactSupport1' | translator: 'base'">Please contact PSP Support at </span>
                                   <a href="tel:877-642-9499"
                                      title="1-877-642-9499"
                                      name="1-877-642-9499">1-877-642-9499</a> 
                                   <span [innerHtml]="'ContactSupport2' | translator: 'base'"> or </span>
                                   <a href="mailto:PSPHelp@tylertech.com"
                                      title="PSPHelp@tylertech.com"
                                      name="PSPHelp@tylertech.com">PSPHelp&#64;tylertech.com</a>
                                   <span [innerHtml]="'ContactSupport' | translator: 'base'"> if you need assistance.</span>
                              </p>
                         </div>
                         <div class="modal-footer">
                              <button class="btn btn-primary ms-2"
                                      (click)="dismissExistingDriverModal()"
                                      [title]="'TryAgain' | translator: 'base'"
                                      name="Try-Again"
                                      id="Try-Again">
                                   <span [innerHtml]="'TryAgain' | translator: 'base'"
                                         [title]="'TryAgain' | translator: 'base'">Try Again</span>
                              </button>
                              <button [routerLink]="'/'"
                                      tag="button"
                                      class="btn btn-outline-primary"
                                      (click)="dismissExistingDriverModal()"
                                      name="Cancel-and-Login"
                                      id="Cancel-and-Login"
                                      [innerHtml]="'CancelAndLogin' | translator: 'base'"
                                      [title]="'CancelAndLogin' | translator: 'base'">
                                   Cancel and Log In
                              </button>
                         </div>
                    </ng-template>

                    <!-- --------------------------------------------------------------------------------- -->

                    <fieldset>
                         <legend class="h3 text-brand-dark"
                                 [innerHtml]="'AddDL' | translator: 'base'">ADD DRIVER'S
                              LICENSE
                         </legend>

                         <div class="justify-content-md-center form-group form-inline">
                              <div class="row gx-2">

                                   <!-- Last Name -->
                                   <div class="col-12 col-md-6 col-lg-6 col-xl pe-md-2 mb-3"
                                        [formGroup]="form">
                                        <label for="driverLastName"
                                               class="form-label  text-nowrap">
                                             <span [innerHtml]="'LastName' | translator: 'base'">Last
                                                  Name</span><span class="text-danger text-center ms-1"
                                                   [title]="'Required' | translator: 'base'">*</span>
                                        </label>
                                        <input formControlName="licenseLastName"
                                               [title]="'LastName' | translator: 'base'"
                                               class="bg-light form-control"
                                               type="text"
                                               id="driverLastName"
                                               name="driverLastName"
                                               required
                                               maxLength="30" />
                                        <span *ngIf="lastName!.invalid && lastName!.dirty"
                                              class="help-block text-danger">
                                             <span *ngIf="lastName!.errors?.['required']"
                                                   [innerHtml]="'UserLastName_required' | translator: 'base'">
                                                  Last name is required.
                                             </span>
                                             <span *ngIf="lastName!.errors?.['pattern']"
                                                   [innerHtml]="'AlphaOnly' | translator: 'base'">
                                                  Last Name contains invalid value(s). Please use letters only.
                                             </span>
                                             <span *ngIf="lastName!.errors?.['maxlength']"
                                                   [innerHtml]="'DriverLicenseLastName_max' | translator: 'base'">
                                                  Last name must be 30 characters or less.
                                             </span>
                                        </span>
                                   </div>

                                   <!-- License Number -->
                                   <div class="col-12 col-md-6 col-lg-6 col-xl ps-md-2 pe-xl-2 mb-3"
                                        [formGroup]="form">
                                        <label for="dlNumber"
                                               class="form-label text-nowrap">
                                             <span [innerHtml]="'LicenseNumber' | translator: 'base'">
                                                  License Number
                                             </span><span class="text-danger text-center ms-1"
                                                   [title]="'Required' | translator: 'base'">*</span>
                                        </label>
                                        <input formControlName="licenseNumber"
                                               [title]="'LicenseNumber' | translator: 'base'"
                                               class="bg-light form-control"
                                               type="text"
                                               id="dlNumber"
                                               name="dlNumber"
                                               required
                                               maxLength="20"
                                               (keyup)="licenseNumberChanged()" />
                                        <span *ngIf="dlNumber!.invalid && dlNumber!.dirty"
                                              class="help-block text-danger">
                                             <span *ngIf="dlNumber!.errors?.['required']"
                                                   [innerHtml]="'LicenseNumber_required' | translator: 'base'">
                                                  License number is required.
                                             </span>
                                             <span *ngIf="dlNumber!.errors?.['pattern']"
                                                   [innerHtml]="'LicenseNumber_invalid' | translator: 'base'">
                                                  License number contains invalid value(s). Please use only letters and
                                                  numbers.
                                             </span>
                                             <span *ngIf="dlNumber!.errors?.['maxlength']"
                                                   [innerHtml]="'LicenseNumber_max' | translator: 'base'">
                                                  License number must be 20 characters or less.
                                             </span>
                                        </span>
                                   </div>

                                   <!-- License State -->
                                   <div class="col-12 col-md-6 col-lg-6 col-xl ps-xl pe-md-2 mb-3"
                                        [formGroup]="form">
                                        <label for="driverState"
                                               class="form-label text-nowrap">
                                             <span [innerHtml]="'LicenseState' | translator: 'base'">
                                                  State
                                             </span><span class="text-danger text-center ms-1"
                                                   [title]="'Required' | translator: 'base'">*</span>
                                        </label>
                                        <select formControlName="licenseState"
                                                class="form-select bg-light"
                                                id="driverState"
                                                name="driverState"
                                                required>
                                             <option value=""
                                                     selected></option>
                                             <option *ngFor="let s of stateList"
                                                     [ngValue]="s">{{ s }}</option>
                                        </select>
                                        <div *ngIf="state!.invalid && state!.dirty"
                                             class="help-block text-danger">
                                             <div *ngIf="state!.errors?.['required']"
                                                  [innerHTML]="'State is required' | translator:'base'">
                                             </div>
                                        </div>
                                   </div>

                                   <div class="col-12 col-md-6 col-lg-6 col-xl ps-md-2 mb-3"
                                        [formGroup]="form">
                                        <button type="button"
                                                class="btn btn-primary addLicenseButton"
                                                (click)="addLicense()"
                                                [disabled]="form.status === 'INVALID'"
                                                [title]="'AddLicense' | translator: 'base'"
                                                [innerHtml]="'AddLicense' | translator: 'base'"
                                                name="Add-License"
                                                id="Add-License">
                                             Add License
                                        </button>
                                   </div>
                                   <div *ngIf="duplicateWasEntered"
                                        class="text-danger text-center ms-1"
                                        [innerHtml]="'DuplicateLicenseError' | translator: 'base'">
                                        License already in list.
                                   </div>
                              </div>
                         </div>
                    </fieldset>

                    <!-- --------------------------------------------------------------------------------- -->

                    <h3 [innerHtml]="'YourLicenses' | translator: 'base'">Your Licenses</h3>
                    <table class="table table-collapsible">
                         <thead>
                              <tr>
                                   <th scope="col"
                                       class="text-nowrap"
                                       [innerHtml]="'LastName' | translator: 'base'"
                                       name="Last-Name">Last Name</th>
                                   <th scope="col"
                                       [innerHtml]="'LicenseNumber' | translator: 'base'"
                                       class="text-nowrap"
                                       name="First-Name">License Number</th>
                                   <th scope="col"
                                       [innerHtml]="'LicenseState' | translator: 'base'"
                                       class="text-nowrap"
                                       name="License-State">License State</th>
                                   <th scope="col"
                                       [innerHtml]="'Actions' | translator: 'base'"
                                       class="text-nowrap"
                                       name="Actions">Actions</th>
                              </tr>
                         </thead>
                         <tbody *ngIf="licenses.length > 0">
                              <tr *ngFor="let l of licenses; let idx = index">
                                   <td class="text-break">
                                        <span class="cell-label"
                                              [innerHtml]="'LastName' | translator: 'base'">Last
                                             Name</span>
                                        {{l.lastName}}
                                   </td>
                                   <td class="text-break">
                                        <span class="cell-label"
                                              [innerHtml]="'LicenseNumber' | translator: 'base'">License
                                             Number</span>
                                        {{l.licenseNumber}}
                                   </td>
                                   <td>
                                        <span class="cell-label"
                                              [innerHtml]="'LicenseState' | translator: 'base'">License
                                             State</span>
                                        {{l.state}}
                                   </td>
                                   <td>
                                        <button type="button"
                                                [title]="'Remove' | translator: 'base'"
                                                class="btn btn-danger btn-sm"
                                                (click)="removeLicense(l)"
                                                [name]="'remove'+idx"
                                                [id]="'remove'+idx">
                                             <span [title]="'Remove' | translator: 'base'"
                                                   [innerHtml]="'Remove' | translator: 'base'">Remove</span>&nbsp;
                                        </button>
                                   </td>
                              </tr>
                         </tbody>
                         <tbody *ngIf="licenses.length === 0">
                              <tr>
                                   <td colspan="4"
                                       class="font-italic text-center">
                                        {{ noRowsText }}
                                   </td>
                              </tr>
                         </tbody>
                    </table>

                    <div class="psuedo-hidden" #pageVooDoo [innerHtml]="translate('Voodoo')">Voodoo||| DO NOT CHANGE TO display:none or
                         translation won't be triggered and grid language will not change on language drop down change.</div>

                    <!-- --------------------------------------------------------------------------------- -->

                    <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                         <div class="btn-group"
                              role="group">
                              <button [routerLink]="wizard.continueLinkRoute(_step)"
                                      (click)="scrollToTop()"
                                      class="btn btn-primary btn-strong"
                                      [title]="'Continue' | translator: 'base'"
                                      [disabled]="hasErrors"
                                      name="driverNext"
                                      id="driverNext">
                                   <span [innerHtml]="'Continue' | translator: 'base'">Continue</span>
                              </button>
                         </div>

                         <div class="btn-group"
                              role="group">
                              <button [routerLink]="wizard.backLinkRoute(_step)"
                                      (click)="scrollToTop()"
                                      class="btn btn-outline-primary"
                                      [title]="'Back' | translator: 'base'"
                                      [innerHtml]="'Back' | translator: 'base'"
                                      name="driverBack"
                                      id="driverBack">
                                   Back
                              </button>
                              <button [routerLink]="wizard._cancelLinkRoute"
                                      tag="button"
                                      class="btn btn-light"
                                      (click)="scrollToTop()"
                                      name="driverCancel"
                                      id="driverCancel"
                                      [innerHtml]="'Cancel' | translator: 'base'"
                                      [title]="'Cancel' | translator: 'base'">
                                   Cancel
                              </button>
                         </div>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"
                          [wizardObj]="wizard"
                          [activeStep]="wizard.visualProgressStep(_step)"
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>